import { MDBContainer } from "mdb-react-ui-kit";
import React, { useMemo } from "react";
import {
    ReviewReadableTO,
    TBreackpointsCarousel,
} from "../../models/common/common";
import styles from "../../styles/detail/Detail.TourReview.module.scss";
import {
    tourReviewSubtitle,
    tourReviewTitle,
} from "../../utils/mockData/homeMocks";
import { randomUid } from "../../utils/randomIds";
import CardReview from "../home/cards/CardReview";
import SectionCarouselLayout from "../common/SectionCarouselLayout";

const TourReviewDetail: React.FC<{ reviewContents: ReviewReadableTO[] }> = ({
    reviewContents,
}) => {
    const itemList = useMemo(
        () =>
            reviewContents.map((item: ReviewReadableTO) => ({
                value: item,
                id: randomUid(),
            })),
        [reviewContents]
    );

    // Breakpoints: 1 card fino a 16 pollici (1920px), 2 card su desktop grandi
    const breackPointCarousel: TBreackpointsCarousel = {
        0: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 10,
        },
        576: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 12,
        },
        992: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 12,
        },
        1200: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 32,
        },
        1400: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 32,
        },
        1600: {
            slidesPerView: 1,
            height: 533,
            spaceBetween: 32,
        },
        1920: {
            slidesPerView: 2,
            spaceBetween: 16,
            height: 568,
        },
    };

    return (
        <MDBContainer
            id="tour-reviews-detail"
            fluid
            className={`${styles.container} ${styles.reviewContainer} align-items-center py-5 px-0`}
        >
            <SectionCarouselLayout
                visibleSlides={2}
                sectionTitle={tourReviewTitle}
                sectionSubTitle={tourReviewSubtitle}
                classNameSlide={styles.tourReviewsSlide}
                breakpointsCarousel={breackPointCarousel}
                centerInsufficientSlides
                isCarouselContained
                navigationPosition="title"
            >
                {itemList.map((el, index) => (
                    <React.Fragment key={el.id}>
                        <CardReview
                            content={el.value}
                            hideStars
                            removeLeftMargin={index === 0}
                        />
                    </React.Fragment>
                ))}
            </SectionCarouselLayout>
        </MDBContainer>
    );
};
export default TourReviewDetail;
